import { useEffect } from "@wordpress/element";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import List from "@mui/material/List";
import {
	fetchEvents,
	selectEventBookings,
} from "store/vino/eventBookingsSlice";
import EventBookingListItem from "./EventBookingListItem";

const CustomerBookings = () => {
	const dispatch = useDispatch();
	const events = useSelector(selectEventBookings);

	useEffect(() => {
		dispatch(fetchEvents());
	}, [dispatch]);

	const container = {
		show: {
			transition: {
				staggerChildren: 0.1,
			},
		},
	};

	const item = {
		hidden: { opacity: 0, y: 20 },
		show: { opacity: 1, y: 0 },
	};

	return (
		<div className="flex flex-col flex-auto flex-shrink-0 w-full">
			<div className="flex flex-col flex-1 max-w-2xl w-full mx-auto px-8 sm:px-16">
				<motion.div
					className="flex flex-wrap"
					variants={container}
					initial="hidden"
					animate="show"
				>
					{!events.length && (
						<div className="flex w-full justify-center text-15 mt-24">
							No events
						</div>
					)}
					<List className="w-full">
						{events.map((event) => (
							<motion.div variants={item} key={event.id}>
								<EventBookingListItem booking={event} />
							</motion.div>
						))}
					</List>
				</motion.div>
			</div>
		</div>
	);
};

export default CustomerBookings;
